const React = require("react");
import * as actions from '../../actions/';
import { connect } from "react-redux";
import axios from 'axios';
const qs = require('querystring');
export class ListItem extends React.Component {
    constructor() {
        super(...arguments);
        this.editShopping = () => {
            let id = parseInt(this.props.product.DisplaySKU);
            if (this.props.DecrementList && this.props.ToggleLogin && this.props.shoppingList) {
                if (this.props.authenticated) {
                    let ShoppingList = this.props.shoppingList.filter((x) => { return x !== id; }).toString();
                    axios.post('/Manage/SetShoppingList', qs.stringify({
                        ShoppingList
                    }))
                        .then(() => {
                        this.props.DecrementList(id);
                    });
                }
                else {
                    this.props.ToggleLogin();
                }
            }
        };
    }
    render() {
        const { product } = this.props;
        return (React.createElement("div", { className: "list-item" },
            React.createElement("i", { className: "fa fa-times-circle remove-icon", onClick: this.editShopping }),
            React.createElement("div", { className: "list-content" },
                React.createElement("a", { href: `/Products/Stores/${product.DisplaySKU}` },
                    React.createElement("h2", null, product.Name),
                    React.createElement("p", { className: "liquor-subtitle" },
                        product.ConsumerCategory,
                        " | ",
                        product.ConsumerType),
                    React.createElement("p", { className: "liquor-subtitle" },
                        product.Country,
                        " | ",
                        product.Region)))));
    }
}
;
export const mapStateToProps = ({ shoppingList, authenticated, signInModal }, ownProps) => {
    return {
        shoppingList,
        authenticated
    };
};
export function mapDispatchToProps(dispatch) {
    return {
        DecrementList: (liquor) => dispatch(actions.DecrementList(liquor)),
        ToggleLogin: () => dispatch(actions.ToggleLogin())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ListItem);
//# sourceMappingURL=list-item.js.map